<template>
  <div v-if="moreCityList.length" mt="16" mx="4">
    <div text="#121212 2xl" font="500">
      {{ t('key.home.more.recommendations') }}
    </div>
    <NuxtLink
      v-for="item in moreCityList" :key="item.cityId"
      :to="{
        path: `/${locale}/rank/${item.countryCode}/${item.countryNameEn}/${item.cityId}`,
        query: {
          ...getCommonQuery(),
          tabId: E_CATEGORY_TYPE.ATTRACTIONS,
        },
      }"
    >
      <div
        mt="4" b="1 solid #00000020" rounded="8" overflow="hidden" flex="~ items-center" px="4" py="2"
        cursor="pointer" class="azgo-haptics-feedback"
      >
        {{ t('key.home.link.things.to.do', [item.cityName]) }}
      </div>
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import { getCommonQuery } from '~/utils/common'
import { E_CATEGORY_TYPE } from '~/enums'

const { t } = useI18n()
const { locale } = useLocale()
const {
  moreCityList,
} = useIntelRecommand()
</script>

<style lang="scss"></style>
